import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-reserve-list",
  "use": "notification-reserve-list-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"notification-reserve-list\">\n  <path fill-rule=\"evenodd\" d=\"M563,450.012v4.54h16v-4.54H563Zm14.476,3.027H564.524v-1.514h12.952v1.514ZM563,456.066v4.541h16v-4.541H563Zm14.476,3.027H564.524V457.58h12.952v1.513Zm-5.714,7.9v-1.7h1.709V463.78h-1.709v-1.7h-1.524v1.7h-1.709v1.514h1.709v1.7h1.524Z\" transform=\"translate(-563 -450)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-reserve-list.svg
// module id = null
// module chunks = 